import { Box, Typography } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import { useTheme } from "@mui/material/styles";

export default function VillagerShopData() {
  const theme = useTheme();

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <PeopleIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
        <Typography variant="h5">Villager Markets</Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Shop data from 2026-03-23
      </Typography>
      <Box
        component="iframe"
        src="https://mcverse.city/mcdealer/"
        sx={{
          width: "100%",
          height: "70vh",
          border: "none",
          borderRadius: "4px",
        }}
        title="Villager Markets"
        allowFullScreen
      />
    </Box>
  );
}
